import React from 'react';
import { Container, Typography, Box, Button, Card, CardContent, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        {/* Main heading */}
        <Typography variant="h2" component="h1" gutterBottom color="primary">
          Family Finance
        </Typography>
        
        {/* Status message */}
        <Typography variant="h6" color="success.main" sx={{ mb: 4 }}>
          Frontend is LIVE
        </Typography>

        {/* Backend API link */}
        <Box sx={{ mb: 4 }}>
          <Link 
            href="https://reinventedsolutions.xyz/api/health" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ fontSize: '1.1rem' }}
          >
            Backend API: reinventedsolutions.xyz/api
          </Link>
        </Box>

        {/* Feature cards */}
        <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 4 }}>
          <Card sx={{ minWidth: 250, maxWidth: 300 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                🔐 Secure Authentication
              </Typography>
              <Typography variant="body2" color="text.secondary">
                JWT-based authentication with role-based access control
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{ minWidth: 250, maxWidth: 300 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                📊 Modern Dashboard
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Clean, responsive interface built with Material-UI
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{ minWidth: 250, maxWidth: 300 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                🚀 Cloud Ready
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Hosted on Hetzner with PostgreSQL
              </Typography>
            </CardContent>
          </Card>
        </Box>

        {/* Action buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button 
            variant="contained" 
            size="large"
            onClick={() => navigate('/auth')}
          >
            Get Started
          </Button>
          <Button 
            variant="outlined" 
            size="large"
            href="https://reinventedsolutions.xyz/api/health"
            target="_blank"
          >
            API Status
          </Button>
        </Box>

        {/* Footer */}
        <Box sx={{ mt: 6, pt: 4, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            Built with React, Flask, and PostgreSQL • Hosted on Hetzner
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};
